import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './NameWithPubdate.module.scss'
import { getFormattedDate } from '../../helpers/date'

function NameWithPubdate({ className, authorName, pubDate, thumbnail }) {
  return (
    <div className={classNames(styles.author, className)}>
      {thumbnail && (
        <div className={styles.authorImg}>
          <GatsbyImage
            image={thumbnail}
            alt={authorName}
            className={styles.img}
          />
        </div>
      )}

      <div>
        <address>{authorName}</address>
        <time dateTime={pubDate}>{getFormattedDate(pubDate)}</time>
      </div>
    </div>
  )
}

NameWithPubdate.propTypes = {
  pubDate: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  thumbnail: PropTypes.object,
  className: PropTypes.string,
}

export default NameWithPubdate
